const SMALL_SCREEN_QUERY = '(max-width: 768px)'

export function isSmallScreen() {
  if (typeof window === 'undefined') {
    return false
  }
  return typeof window.matchMedia === 'function'
    ? window.matchMedia(SMALL_SCREEN_QUERY).matches
    : window.innerWidth <= 768
}

export function redirectToMainLogin() {
  const base = (process.env.VUE_APP_INDEX || 'https://wesitrans.com').replace(/\/+$/, '')
  window.location.assign(`${base}${isSmallScreen() ? '/h5/login' : '/login'}`)
}

export {SMALL_SCREEN_QUERY}
